import React, { useEffect } from 'react'
import notap_logo from '../../assets/images/notap_logo.png'
import { navigationStructure } from '../../utils/navStructure'
import { Link } from 'react-router-dom'
import { appUrls } from '../../utils/urls/appUrls'

export default function NavbarLayout() {


  return (
    <nav className="navbar customer navbar-expand-lg fixed-top navbar-light bg-light">
        <div className="container-fluid">
            <Link className="navbar-brand order-1 order-lg-1" to={appUrls.home_page}>
              <img className='app-logo' src={notap_logo} alt='primetic logo' />
            </Link>
            <button className="navbar-toggler border-0 order-3 order-lg-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse order-3 order-lg-1" id="navbarNav">
            <ul className="navbar-nav ms-lg-auto">
                {navigationStructure.general_navigation.map((option)=>{
                  return <li key={option.id} className="nav-item">
                    <Link to={option.url} className={`nav-link fw-bold text-primary`} aria-current="page">{option.name}</Link>
                  </li>
                })}
            </ul>
            </div>
        </div>
    </nav>
  )
}
